import React, { useEffect, useState } from 'react';
import ErrorBoundary from 'components/ErrorBoundary';
import AdjustmentTable from './AdjustmentTable';
import useAxios from 'hooks/useAxios';
import { getUpdatedFilter } from 'utils/helper';
import { cloneDeep, filter } from 'lodash';
import { Button, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { Field, Formik } from 'formik';
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import DatePicker from "react-datepicker";
import Calendar from "assets/icon/calendar-icon.svg";
import { toast } from 'react-toastify';
import ReactInputMask from 'react-input-mask';
import moment from 'moment';
import { dateFormate } from 'utils/columns';
import reseticon from "assets/icon/reset.svg";
import search from "assets/icon/search.svg";
import save from "assets/icon/save.svg";
import cancel from "assets/icon/cancel.svg";
import Loader from 'components/Loader';



let initialFilters = {
    currentPage: 1,
    pageSize: 10,
    orderBy: '',
    order: '',
    filters: [],
    AccumulatorIDs: [],
};

let hasDatePopupOpen = false;
const Adjustment = ({ tenantID, rowData, AccountTypeID ,recall}) => {
    const API = useAxios();
    const [state, updateState] = useState({
        data: [],
        loading: false,
        records: 0,
        reset: false,
    });

    const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));
    const [colFilter, setColFilter] = useState([]);
    const [openPharmacy, setOpenPharmacy] = useState(false);
    const [modal, setModal] = useState(false);
    const [adjustmentDate, setAdjustmentDate] = useState('');
    const [dateerror, setDateError] = useState("");
    const [packageserror, setpackageserror] = useState("");
    const [commenterror, setcommenterrror] = useState("");
    const [packages, setPackages] = useState('');
    const[saveflag,setSaveflag] = useState(false);
    const [comment, setComment] = useState('');
    const [errorMessage, setErrorMessage] = useState('')
    const [loadingAdd,setLoadingAdd] = useState(false);

    useEffect(() => {
        initialFilters = {
            currentPage: 1,
            pageSize: 10,
            orderBy: '',
            order: '',
            filters: [],
            AccumulatorIDs: [],
        };

        setState({ data: [], records: 0 });

        if (AccountTypeID) {
            const { accumulatorID } = rowData;
            if (AccountTypeID) {
                initialFilters.filters = getUpdatedFilter(
                    'AccountTypeID',
                    AccountTypeID.toString(),
                    initialFilters
                );
            }
            var acIds = [];
            acIds = accumulatorID;
            initialFilters.currentPage = 1;
            initialFilters.AccumulatorIDs = [acIds];
            initialFilters.order = 'desc';
            initialFilters.orderBy = 'ModifiedDate';
            fetchAdjustmentData(initialFilters);
        }
    }, [AccountTypeID]);

    const fetchAdjustmentData = async (pageDetails = {}, hasColumnFilter) => {
        debugger;
        setState({ loading: true });
        let filter = { ...pageDetails };
        if (hasColumnFilter) {
            filter.filters = [...initialFilters.filters, ...pageDetails.filters];
            //initialFilters.filters = [...filter.filters];
        } else {
            initialFilters = { ...initialFilters, ...filter };
        }
        try {
            const { data } = await API.post(
                `SBTenant/${tenantID}/Inventory/Adjustments/${rowData.ndc}`, filter,
                {
                    hasDefaultURL: true,
                    // hideLoder: true,
                });
           if (data?.items?.length > 0) {
                setState({
                    data: data.items,
                    records: data.totalRecords,
                    loading: false,
                });
                recall(data.items)

            } else {
                setState({
                    data: [],
                    records: 0,
                    loading: false,
                });
            }
        } catch (error) {
            console.error('API Error:', error);
            setState({ loading: false, data: [], records: 0 });
        }
    };
    const checkvalidation = () => {
        debugger;
         let hasError = false;
        if (adjustmentDate?.length == 0 || adjustmentDate == null) {
            setDateError("Adjustment Date is a required field");
            hasError = true;
            // setLoadingAdd(true);
        }
        if (packages?.length == 0) {
            setpackageserror("Packages is a required field");
            hasError = true;
            // setLoadingAdd(true);
        }
        if (comment?.length == 0) {
            setcommenterrror("Notes is a required field");
            hasError = true;
            // setLoadingAdd(true);
        }
        if(adjustmentDate?.length!=0 && packages?.length!=0 && comment?.length==0){
            hasError = true;
            // setLoadingAdd(false);
        }
        else{
            hasError = false;
            // setLoadingAdd(true);
        }
        return hasError;
          }

    const handleSubmit = async () => {
        debugger;
        // checkvalidation();
        if (checkvalidation()) {
          return true;
        }
        
        let payload = {}
        payload.AccumulatorID = rowData.accumulatorID,
            payload.AccountTypeID = AccountTypeID,
            payload.AdjestmentDate = moment(new Date(adjustmentDate)).format('YYYY-MM-DD'),
            payload.Comments = comment,
            payload.Packages = packages
        if (packages.length > 0 && adjustmentDate != undefined && comment.length > 0) {
            debugger
            try {
              setLoadingAdd(true);
                const { data } = await API.post(`SBTenant/${tenantID}/Inventory/AddAdjustments/${rowData.ndc}`, payload,
                    {
                        hasDefaultURL: true,
                        hideLoder: true,
                    });
                debugger
                if (data.error == true) {
                  toast.error(data.message);
                  setLoadingAdd(false);
                  handelCancel();
                } else {
                  toast.success(data.message);
                  setSaveflag(false);
                  setLoadingAdd(false);
                  refetch(true);
                  handelCancel();
                }
            } catch (error) {
                console.log(error);
            }
        }

    }


    const handleExport = () => {
        //debugger;
        const { access_token } =
            JSON.parse(localStorage.getItem('pharmaforce')) || {};
        let filter = cloneDeep(initialFilters);
        if (colFilter && colFilter.filters !== undefined) {
            filter.filters = [...filter.filters, ...colFilter.filters];
        }

        const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/Inventory/ExportAdjustments/${rowData.ndc}?access_token=${access_token}`;
        onExport(action, filter);
    };
    const handleSearchColumnFilters = async (columnFilters) => {
        initialFilters.currentPage = 1;
        setColFilter(columnFilters);
        await fetchAdjustmentData({ ...initialFilters, ...columnFilters }, true);
    };

    const onPageChange = (filter, hasFilter) => {
        if (hasFilter) {
            fetchAdjustmentData(filter, true);
        } else {
            fetchAdjustmentData(filter);
        }
    };

    const refetch = (hasReset) => {
        if (hasReset) {
            setColFilter([]);
            initialFilters = {
                ...initialFilters,
                currentPage: 1,
            };
        }
        fetchAdjustmentData(initialFilters);
    };

    const manvalPharmacy = () => {
        setOpenPharmacy(!openPharmacy);
        setModal(!modal);
        setAdjustmentDate("");
        setDateError("");
        setPackages("");
        setpackageserror("");
        setComment("");
        setcommenterrror("");
    }
    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };

    const handelEffictiveDate = (startDate) => {
        setAdjustmentDate(startDate);
        if (startDate) {
            setDateError("")
        }
        if (!startDate) {
            setDateError("Adjustment Date is a required field")
        }
        //addpayorData.effectivedate = startDate
    };
    const handleStartDate = (effectivedate) => {
        let stDate = dateFormate(effectivedate);
        setAdjustmentDate(stDate);
        //addpayorData.effectivedate = moment(new Date(effectivedate)).format('MM/DD/YY');
        if (stDate) {
            setDateError("");
        }
        else {
            setDateError("Adjustment Date is a required field");
        }
    };

    const handleStartDateRaw = (e) => {
        var valdt = new Date();
        var val = e.target.value;
        var dt = moment(val, "MM/DD/YYYY", true);
        var isValid = dt.isValid();
        //setHasInteracted(true);
        if (!val || isValid == false || val < valdt) {
            setAdjustmentDate(null);
            // if (hasInteracted) {
            //   setDateError("Effective Date is a required field");
            // }
        } else if (isValid && val >= valdt) {
            handleStartDate(e.target.value);
        }
    };

    const handleDateClick = (id) => {
      debugger;
        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };

    const handlePacOnChange = ({ target: { value } }) => {
        setPackages(value)
        if (value.length > 0) {
            setpackageserror("");
        }
        if (value.length == 0) {
            setpackageserror("Packages is a required field");
        }
    };

    const handleCommentOnChange = ({ target: { value } }) => {
        setComment(value)
        if (value.length > 0) {
            setcommenterrror("");
        }
        if (value.length == 0) {
            setcommenterrror("Note is a required field");
        }
    };

    const handelCancel = () => {
        manvalPharmacy();
        setAdjustmentDate("");
        setDateError("");
        setPackages("");
        setpackageserror("");
        setComment("");
        setcommenterrror("");
    };

    return (
      <div>
        <ErrorBoundary>
          <AdjustmentTable
            data={state.data}
            loading={state.loading}
            onExport={handleExport}
            totalSize={state.records}
            filters={initialFilters}
            onPageChange={onPageChange}
            setLoading={(value) => setState({ loading: value })}
            onSearchColumnFilters={handleSearchColumnFilters}
            refetch={refetch}
            manvalPharmacy={manvalPharmacy}
          />
        </ErrorBoundary>
        <Modal isOpen={openPharmacy} toggle={manvalPharmacy}>
          <ModalHeader toggle={manvalPharmacy}>
            <h5 className="f-15 text-primary font-weight-700 mt-2">
              Add Adjustments
            </h5>
          </ModalHeader>
          <ModalBody>
            {loadingAdd && <Loader />}
            <Formik
              children={(props) => {
                return (
                  <div>
                    <Row>
                      <Col className="required-date">
                        <FormGroup>
                          <Label>Adjustment Date</Label>
                          <InputGroup onMouseLeave={handleMouseLeave}>
                            <DatePicker
                              id="effectivedate"
                              name="effectivedate"
                              selected={adjustmentDate}
                              onChange={(e) => {
                                handleStartDate(e);
                              }}
                              onChangeRaw={handleStartDateRaw}
                              dateFormat="MM/dd/yyyy"
                              placeholderText="Select a date"
                              autoComplete="off"
                              customInput={
                                <ReactInputMask
                                  mask="99/99/9999"
                                  value={adjustmentDate}
                                />
                              }
                            />
                            <InputGroupText
                              onClick={() => handleDateClick("effectivedate")}
                            >
                              <img src={Calendar} alt="" />
                            </InputGroupText>
                          </InputGroup>
                          {dateerror && (
                            <div className="text-danger font-size-12">
                              {dateerror}
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label>Packages</Label>
                          <Input
                            id="Criteria"
                            name="Criteria"
                            type="number"
                            className="required"
                            value={packages}
                            autoComplete="off"
                            onChange={handlePacOnChange}
                            // onKeyDown={(e) => {
                            //     if (e.key === 'e' || e.key === '+' || e.key === '-') { e.preventDefault(); }}}
                          />
                          {packageserror && (
                            <div className="text-danger font-size-12">
                              {packageserror}
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label>Notes</Label>
                          <Input
                            id="Criteria"
                            name="Criteria"
                            type="text"
                            className="required"
                            autoComplete="off"
                            onChange={handleCommentOnChange}
                          />
                          {commenterror && (
                            <div className="text-danger font-size-12">
                              {commenterror}
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                );
              }}
            ></Formik>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              //disabled={addDisabled}
              className="search"
              onClick={handleSubmit}
              disabled={saveflag}
            >
              <span className="right_5">
                <img src={save} alt="" />
              </span>{" "}
              Save
            </Button>{" "}
            <Button color="primary" onClick={handelCancel} className="reset">
              <span className="right_5">
                <img src={cancel} alt="" />
              </span>{" "}
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
};

export default Adjustment;
